export default {
  SearchPlaceholder: 'Search acceleration IPv4/IPv6/domain name',
  ClientName: 'Client Name',
  AcceleratedIP: 'Accelerated IP',
  SpeedUpDomainName: 'Speed ​​up domain name',
  WhitelistType: 'Whitelist type',
}